import CategoriesSlider from "../MyComponents/Categories";
import ProductSlider from "../MyComponents/ProductSlider";
import LoginBoom from "../MyComponents/LoginBoom";


function Products() {
    return (
        <>
            <div className="parent-categories">
                <CategoriesSlider />
            </div>
            <div className="parent-products">
                <ProductSlider category='Medicine' />
            </div>
            <div className="parent-products">
                <ProductSlider category='Surgical Product' />
            </div>
            <div className="parent-products">
                <ProductSlider category='Tablets' />
            </div>
            <div className="parent-products">
                <ProductSlider category='Consumer Running Products' />
            </div>
            <LoginBoom/>
        </>
    )

}

export default Products;